module.exports = __webpack_public_path__ + "img/cotoclub4.4e850e7d.png";